import { State } from 'redux/types';
import { SelectedAudioState } from './types';

export const selectedAudioSelector = (state: State): SelectedAudioState =>
  state.getIn(['sampleAudio', 'selectedAudio']);

export const libraryIsFetchingSelector = (state: State): boolean =>
  state.getIn(['sampleAudio', 'library', 'isFetching']);
